import React from 'react';
import TextFieldComponent from '../components/Common_Components/FieldTypes/TextField';
import MultipleLinesTextComponent from '../components/Common_Components/FieldTypes/MultipleLinesText';
import NumberFieldComponent from '../components/Common_Components/FieldTypes/NumberField';
import ImagePickerComponent from '../components/Common_Components/FieldTypes/ImagePicker';
import ProfileImagePickerComponent from '../components/Common_Components/FieldTypes/ProfileImagePicker';
import { NameFieldComponent } from '../components/Common_Components/FieldTypes/NameField';
import AgeComponent from '../components/Common_Components/FieldTypes/Age';
import BirthdatePickerComponent from '../components/Common_Components/FieldTypes/BirthdatePicker';
import MapAddressComponent from '../components/Common_Components/FieldTypes/MapAddress';
import EmailComponent from '../components/Common_Components/FieldTypes/Email';
import PhoneNumberComponent from '../components/Common_Components/FieldTypes/PhoneNumber';
import CommentsComponent from '../components/Common_Components/FieldTypes/Comments';
import CustomNoteComponent from '../components/Common_Components/FieldTypes/CustomNote';
import RadioButtonComponent from '../components/Common_Components/FieldTypes/RadioButton';
import CheckBoxComponent from '../components/Common_Components/FieldTypes/CheckBox';
import DropDownMenuComponent from '../components/Common_Components/FieldTypes/DropDownMenu';
import AutocompleteComponent from '../components/Common_Components/FieldTypes/Autocomplete';
import GlassOverImageComponent from '../components/Common_Components/FieldTypes/GlassOverImage';
import GlassOverImageSVGComponent from '../components/Common_Components/FieldTypes/GlassOverImageSVG';
import GlassOverImageAdvancedComponent from '../components/Common_Components/FieldTypes/GlassOverImageAdvanced';

export const fieldSelector = (item, items, setItems, get_item_by_id, get_item_index_by_id, setParentDragDisabled=() => {}, mode='design', contextData=null) => {
    const { type, properties } = item;
    
    // Pass mode to field properties
    const enhancedProperties = {
        ...properties,
        mode
    };
    
    // Build fieldContext for smart autocomplete
    const fieldContext = contextData ? {
        databaseName: contextData.databaseName,
        dbGroupName: contextData.dbGroupName,
        fieldName: item.name,
        fieldIndex: get_item_index_by_id(item.id),
        allFields: items
    } : null;

    const valueUpdaterCallback = (newValue) => {
        const itemId = item.id;
        console.log("valueUpdaterCallback called!");
        console.log("  Item ID:", itemId);
        console.log("  New value:", newValue);
        console.log("  Current items:", items);
        const item_index = get_item_index_by_id(itemId);
        console.log("  Item index:", item_index);
        const new_items = [...items];
        new_items[item_index].value = newValue;
        console.log("  Updated items:", new_items);
        setItems(new_items);
    };

    const validityUpdaterCallback = (isValid) => {
        const itemId = item.id;
        console.log("Validity updated for item ID:", itemId, "Is valid:", isValid);
        const item_index = get_item_index_by_id(itemId);
        const new_items = [...items];
        new_items[item_index].valid = isValid;
        setItems(new_items);
    };

    switch (type) {
        case 'TextField':
            return <TextFieldComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'MultipleLinesText':
            return <MultipleLinesTextComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'NumberField':
            return <NumberFieldComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Image Picker':
            return <ImagePickerComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Profile Image Picker':
            return <ProfileImagePickerComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Name':
            return <NameFieldComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Age':
            return <AgeComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Birthdate Picker':
            return <BirthdatePickerComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Map address':
            return <MapAddressComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Email':
            return <EmailComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Phone number':
            return <PhoneNumberComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Comments':
            return <CommentsComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Custom Note':
            return (
                <CustomNoteComponent id={item.id}
                    properties={enhancedProperties}
                    value={item.value}
                    valueUpdaterCallback={valueUpdaterCallback}
                    validityUpdaterCallback={validityUpdaterCallback}
                    setParentDragDisabled={setParentDragDisabled}
                />
            );
        case 'Radio Button':
            return <RadioButtonComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'CheckBox':
            return <CheckBoxComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Dropdown Menu':
            return <DropDownMenuComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Autocomplete':
            return <AutocompleteComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} fieldContext={fieldContext} />;
        case 'Glass Over Image':
            return <GlassOverImageComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Glass Over Image SVG':
            return <GlassOverImageSVGComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} />;
        case 'Glass Over Image Advanced':
            return <GlassOverImageAdvancedComponent id={item.id} properties={enhancedProperties} value={item.value} valueUpdaterCallback={valueUpdaterCallback} validityUpdaterCallback={validityUpdaterCallback} fieldContext={fieldContext} />;
        default:
            return null;
    }
};
